// @ts-check
import asCatalog from '../../components/asCatalog.js';
import asCatalogSections from '../../components/asCatalogSections.js';
import asMyList from '../../components/asMyList.js';
import VieVinumCatalog from './Catalog/VieVinumCatalog';
import VieVinumMyList from './MyList/VieVinumMyList';
import VieVinumPreview from './Preview/VieVinumPreview';

export const Catalog = asCatalog(VieVinumCatalog);
export const CatalogNoBleed = asCatalog(VieVinumCatalog, { bleed: 0 });

export const Preview = asCatalogSections(VieVinumPreview);

export const MyList = asMyList(VieVinumMyList);
